@import "../../shared";

.glossary-item {
  /* FIX: Forces the <div> to wrap exactly around the text instead of stretching 100% width */
  display: inline-block; 
  
  @media (min-width: $breakpoint-md) {
    position: relative;
  }
  
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  border-bottom: 0.2rem solid $header-background;

  & .glossary-item-card {
    position: absolute;
    left: 1.5rem;
    right: 1.5rem;
    min-height: 16rem;
    border-radius: 0.2rem;
    background-color: $background-color-primary;
    box-shadow: 0 0.7rem 2rem 0 rgba(108, 130, 209, 0.4); /* Fixed typo '2ren' to '2rem' here as well */
    padding: $spacing-gutter 2rem;
    z-index: 9999;

    display: none;

    &.--display {
      display: inline-block;
    }

    &::after {
      @media (min-width: $breakpoint-md) {
        display: block;
      }
      display: none;
      content: "";
      position: absolute;
      top: 100%;
      margin-left: 0.5rem;
      border-width: 0.8rem;
      border-style: solid;
      border-color: $background-color-primary transparent transparent
        transparent;
    }

    @media (min-width: $breakpoint-md) {
      bottom: 100%;
      width: 32rem;
      left: 0;
      right: unset;
      flex-direction: column;
      align-items: flex-start;

      &.--display {
        display: flex;
      }

      &.--right {
        left: unset;
        right: 0;

        &::after {
          margin-left: -0.5rem !important;
          align-self: flex-end;
        }
      }
    }

    & .glossary-item-card__title {
      color: $red-section-heading;
      font-size: $font-size-medium;
      font-weight: 800;
      letter-spacing: $letter-spacing-normal;
      line-height: 2.8rem;
      text-align: left;
      margin: 0;
      padding: 0;
    }

    & .glossary-item-card__content {
      color: $text-color;
      font-size: $font-size-small;
      letter-spacing: $letter-spacing-medium;
      line-height: 2rem;
      text-align: left;
      margin: 0;
      padding: 0.4rem 0 0 0;
    }

    & .glossary-item-card__content a {
      font-size: inherit;
      font-weight: inherit;
      color: inherit;
      letter-spacing: inherit;
      text-align: inherit;
      border-bottom: 0.2rem solid #5768a8;
      position: relative;
    }
  }
}
